<style>
  .selected-pink {
  background: #efefef !important;
}
</style>
@if (changes_flag==true) {
  <div class="calc-warning">Please remember to update calculations.</div>
}
@if (sheet_ready && (!restricted_access ||  (restricted_access===true && permissions.view_process_data))) {
  @if (appScope.isNotMobile) {
    <ng-container [ngTemplateOutlet]="nonMobileTable"></ng-container>
  }
  @if (!appScope.isNotMobile) {
    <ng-container [ngTemplateOutlet]="mobileTable" class="mobile-log"></ng-container>
  }
}
@if (restricted_access===true && !permissions.view_process_data) {
  <div>You do not have permission to
    view this data.
  </div>
}

<ng-template #nonMobileTable>
  <div>
    <table mat-table id="shift_table" #logSheetTable class="shift_table table-bordered" cellspacing="0"
      [dataSource]="dataSource"
      [ngClass]="{'editing-layout':editingLayout}">

      <ng-container matColumnDef="group">
        <th mat-header-cell *matHeaderCellDef [ngClass]="{'editing-layout':editingLayout}" style="width:30px;" sticky>
          <div></div>
        </th>
        <!--<td class="th" [attr.rowspan]="report_groups[series.attributes.report_group].length"-->
        <ng-container *matCellDef="let series;">
          @if (report_groups[series.attributes.report_group].indexOf(series)===0) {
            <td mat-cell
              [rowSpan]="report_groups[series.attributes.report_group].length"
              [ngClass]="{'alt': report_groups_names.indexOf(series.attributes.report_group) % 2 == 0}"
              #groupCell
              class="group-header vertical-group-header vertical-cell"
              [style.height]="'24px'">
              <div class="rotated-label" [matTooltip]="series.attributes.report_group">
                <div [style.width]="'24px'"><span class="vertical-text">{{series.attributes.report_group}}</span>
              </div>
            </div>
          </td>
        }
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th *matHeaderCellDef mat-header-cell sticky [ngClass]="{'editing-layout':editingLayout}">
      </th>
      <td *matCellDef="let series" mat-cell>
        <div class="row center">
          <i class="edit-inline hide-xs" (click)="editSeries(series)"></i>
        </div>
      </td>
    </ng-container>

    <!--Name-->
    @if (row_headers.includes('name')) {
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell sticky
          [ngClass]="{'is-sticky-left':isSticky.name, 'editing-layout':editingLayout}"
          [style.width]="format_dict['name'].width + 'px'"
          [resizable]="format_dict['name']" (resizable)="format_dict['name'].width=$event">
          <div>Series</div>
        </th>
        <td *matCellDef="let series"
          [ngClass]="{'bold': hovering_events.includes(series.id),'is-sticky-left':isSticky.name,}"
          class="align-left" mat-cell>
          <div class="row center"
            [style.width]="format_dict['name'].width + 'px'">
            <span style="white-space: nowrap;padding:2px 4px 2px 2px;"
              [dblClickCopy]="series.attributes.name"
              [matTooltip]="series.attributes | nameOrDescription"
            [matTooltipShowDelay]="tooltipShowDelay">{{series.attributes.name}}</span>
          </div>
        </td>
      </ng-container>
    }

    <!--Alias-->
    @if (row_headers.includes('alias')) {
      <ng-container matColumnDef="alias">
        <th *matHeaderCellDef [ngClass]="{'is-sticky-left':isSticky.alias, 'editing-layout':editingLayout}"
          mat-header-cell
          [style.width]="format_dict['alias'].width + 'px'"
          [resizable]="format_dict['alias']" (resizable)="format_dict['alias'].width=$event">
          <div>Alias</div>
        </th>
        <td mat-cell *matCellDef="let series" class="align-left" (focus)="setComment($event, series, null)"
          [ngClass]="{'bold': hovering_events.includes(series.id),'is-sticky-left':isSticky.alias}">
          <div [style.width]="format_dict['alias'].width + 'px'"
            [matTooltip]="series.attributes | nameOrDescription"
            [dblClickCopy]="series.attributes.name"
            [matTooltipShowDelay]="tooltipShowDelay">{{series.attributes.alias}}
          </div>
        </td>
      </ng-container>
    }

    <!--Description-->
    @if (row_headers.includes('description')) {
      <ng-container matColumnDef="description">
        <th *matHeaderCellDef [ngClass]="{'is-sticky-left':isSticky.description, 'editing-layout':editingLayout}"
          mat-header-cell
          [style.width]="format_dict['description'].width + 'px'" [matTooltip]=""
          [resizable]="format_dict['description']" (resizable)="format_dict['description'].width=$event">
          <div>Description</div>
        </th>
        <td mat-cell *matCellDef="let series" class="align-left" (focus)="setComment($event, series, null)"
          [ngClass]="{'bold': hovering_events.includes(series.id),'is-sticky-left':isSticky.description}"
          [style.width]="format_dict['description'].width + 'px'">
          <div [matTooltip]="series.attributes | nameOrDescription"
            [dblClickCopy]="series.attributes.name"
            [matTooltipShowDelay]="tooltipShowDelay">{{series.attributes.description}}
          </div>
        </td>
      </ng-container>
    }

    <!-- Comments Column -->
    <ng-container matColumnDef="comment">`
      <th mat-header-cell *matHeaderCellDef [ngClass]="{'editing-layout':editingLayout}"
        [style.width]="format_dict['comment'].width + 'px'"
        [resizable]="format_dict['comment']" (resizable)="format_dict['comment'].width=$event">
        <div><i class="icon-comment-invert" style="padding-top:4px;"></i></div>
      </th>
      <td mat-cell *matCellDef="let series" class="align-center" (focus)="setComment($event, series, null)">
        @if (series_events[series.id]) {
          <div (mouseenter)="commentIconHover(series_events[series.id])"
            (mouseleave)="cellMouseLeave()"
            style="padding:2px 4px 2px 2px;"><i class="icon-inline-comment" (click)="toggleComments(true)"></i>
          </div>
        }
        @if (!series_events[series.id]) {
          <div style="padding:2px 4px 2px 2px;">
            <i (click)="toggleComments(true)" class="icon-comment-invert" style="width:28px;"></i>
          </div>
        }
      </td>
    </ng-container>

    <!-- Extra columns (Value/Aggregate, Unit, Status) -->
    @for (column of columns; track trackByFunction($index, column)) {
      <ng-container matColumnDef="{{column}}">
        <th mat-header-cell *matHeaderCellDef [ngClass]="{'editing-layout':editingLayout}"
          [style.width]="format_dict[column].width + 'px'"
          [resizable]="format_dict[column]" (resizable)="format_dict[column].width=$event">
          @if (column === 'Value') {
            <div>Aggregate</div>
          }
          @if (column !== 'Value') {
            <div>{{column}}</div>
          }
        </th>
        <td mat-cell *matCellDef="let series" (focus)="setComment($event, series, null)" tabindex="0">
          <!--[ngClass]="{'warning': series.status==2, 'error': series.status==3}"-->
          @if (column === 'Value') {
            <!--@if (!(editAggregation && !series.saving && saveAllowed(series, dtp.start.toISOString()))) { <div>-->
            @if (!editAggregation || series.saving || !saveAllowed(series, dtp.start.toISOString())) {
              <div
                [ngClass]="{'warning': series.status==2, 'error': series.status==3}">
                <div class="align-right">{{series.total | significantNumbers:significant_numbers}}</div>
              </div>
            }
            @if (editAggregation && !series.saving && saveAllowed(series, dtp.start.toISOString())) {
              <input
                type="number" step="any"
                (mousewheel)="$event.preventDefault();"
                (change)="aggregationChange(series,series.total);"
                [(ngModel)]="series.total" style="border:2px; width: 4em;"
                matTooltip="Aggregation: {{series.attributes.aggregation}}, Sample period:{{series.attributes.sample_period}}">
            }
          }
          @if (column === 'Status') {
            <span class="fa flag flag--status fa-warning"
              [ngClass]="{'warning-none': series.status==1, 'warning' : series.status==2, 'error': series.status==3}">
            </span>
          }
          @if (column === 'Units') {
            <div>{{series.attributes.engineering_unit_name}}</div>
          }
          @if (column !== 'Value' && column !=='Status') {
            <div class="align-right">{{series[column] | significantNumbers:significant_numbers}}</div>
          }
        </td>
      </ng-container>
    }

    <!-- Timestamps section -->
    @for (time of times; track trackByFunction(c, time); let c = $index) {
      <ng-container
        [matColumnDef]="timeColumnsCache[time.period_end]">
        <th mat-header-cell *matHeaderCellDef [ngClass]="{'editing-layout':editingLayout}"
          [style.width]="format_dict['time'].width + 'px'"
          [style.min-width]="c===0?'':format_dict['time'].width + 'px'"
          [resizable]="c===0?format_dict['time']:{allow_resize:false}" (resizable)="format_dict['time'].width=$event"
          [title]="(time.period_start | stringDate) + ' - ' + ( time.period_end | stringDate)">
          <div style="margin-left:4px;">{{(time.period_start | stringDate : {date_separator: '-'})}} -</div>
          <div>{{(timeColumnsCache[time.period_end])}}</div>
        </th>
        <td (click)="setFocus($event)" (focus)="setComment($event, series, time);"
          *matCellDef="let series; let r=index;" [id]="'td_' + r + '_' + c + '_' + tileId"
          class="align-right values" mat-cell tabindex="0">
          @if (shouldShowInput(series,time)) {
            <input
              (focus)="setComment($event, series, time)"
              [id]="'inputtd_' + r + '_' + c + '_' + tileId"
              step="any" tabindex="1"
              type="number"
              (mousewheel)="$event.preventDefault();"
              (change)="dataChange(series, time, $event)"
              [value]="series[time.period_end].attributes.value"
                 [ngClass]="{'warning': series[time.period_end] && series[time.period_end].warning,
                'error': series[time.period_end] && series[time.period_end].error,
                'log-sheet-cell-save-failed': series[time.period_end] && series[time.period_end].save_state === 'failed'}"
              [title]="(series[time.period_end] && series[time.period_end].save_error) || ''"
              [attr.aria-invalid]="series[time.period_end] && series[time.period_end].save_state === 'failed' ? 'true' : null"
              [attr.aria-describedby]="series[time.period_end] && series[time.period_end].save_state === 'failed' ? ('save_err_' + r + '_' + c + '_' + tileId) : null"
              style="border:0; width: 100%; "/>
            @if (series[time.period_end] && series[time.period_end].save_state === 'failed') {
              <span
                [id]="'save_err_' + r + '_' + c + '_' + tileId"
                class="cdk-visually-hidden">{{series[time.period_end].save_error}}</span>
            }
          }
          <div
            style="display: none;">{{series.attributes.value | formatNumber:null:significant_numbers:null:!significant_numbers:series}}
          </div>
          @if (series[time.period_end] && (series[time.period_end].saving || !saveAllowed(series, time.period_end) || editAggregation)) {
            <div
              >
              @if (shouldShowFirst(series, time)) {
                <span
                  [ngClass]=" missing_values[series.attributes.name] && missing_values[series.attributes.name][time.period_end] ?'missing-values' :''">
                {{calc_data[series.attributes.name][time.period_end] | formatNumber:null:significant_numbers:null:!significant_numbers:series}}</span>
              }
              @if (series.attributes.can_edit && !dtpCoarserGranularity(series) && !series.saving && series[time.period_end]) {
                <span
                  >
                {{series[time.period_end].attributes.value | formatNumber:null:significant_numbers:null:!significant_numbers:series}}</span>
              }
              @if (series.attributes.can_edit && dtpCoarserGranularity(series) && calc_data[series.attributes.name]) {
                <span
                  >
                {{calc_data[series.attributes.name][time.period_end] | formatNumber:null:significant_numbers:null:!significant_numbers:series}}</span>
              }
            </div>
          }
        </td>
      </ng-container>
    }

    <tr *matHeaderRowDef="row_headers;" mat-header-row></tr>
    <tr (focus)="setComment($event, row, null)" *matRowDef="let row; columns: row_headers" mat-row
      [rowResizable]="rowHeightDict?.row_height"
      (rowResizable)="rowHeightDict.row_height.height=$event"
      [style.height]="rowHeightDict?.row_height?.height ? rowHeightDict.row_height.height + 'px' : 'auto'"
      [style.min-height]="rowHeightDict?.row_height?.height ? rowHeightDict.row_height.height + 'px' : 'unset'"
    tabindex="999"></tr>
  </table>
</div>
</ng-template>


<ng-template #mobileTable>
  @if (sheet_ready && times.length > 0 && !restricted_access || (restricted_access===true && permissions.view_process_data)) {
    <div
      style="margin-bottom:30px;">
      @for (series of series_data; track series) {
        <div class="row"
          style="align-items:center; margin-top:10px; border-bottom: 1px solid #f1f1f1;">
          <label style="width: 54%;text-align:right;margin-right:10px;margin-left:10px;">
            <span>{{series.attributes | nameOrDescription}}</span>
          </label><br/>
          <div tabindex="0" (focus)="setComment($event, series, null)">
            <input type="number" step="any" [(ngModel)]="series[dtp.end.toISOString()].attributes.value"
              [ngModelOptions]="{updateOn: 'blur'}"
              (change)="dataChange(series, {period_start: dtp.start.toISOString(),period_end: dtp.end.toISOString()},$event);"
               [ngClass]="{warning: series[dtp.end.toISOString()] && series[dtp.end.toISOString()].warning,
               error: series[dtp.end.toISOString()] && series[dtp.end.toISOString()].error,
               'log-sheet-cell-save-failed': series[dtp.end.toISOString()] && series[dtp.end.toISOString()].save_state === 'failed'}"
              [title]="(series[dtp.end.toISOString()] && series[dtp.end.toISOString()].save_error) || ''"
              [attr.aria-invalid]="series[dtp.end.toISOString()] && series[dtp.end.toISOString()].save_state === 'failed' ? 'true' : null"
              [attr.aria-describedby]="series[dtp.end.toISOString()] && series[dtp.end.toISOString()].save_state === 'failed' ? ('save_err_mobile_' + series.id + '_' + tileId) : null"
              style="text-align:right; margin-bottom:10px; border:1px solid #ccc; width: 8em; height: 3em; padding:4px;cursor:pointer;"
              [ngStyle]="{'background-color': (series[dtp.end.toISOString()] && series[dtp.end.toISOString()].saving || !saveAllowed(series, dtp.end.toISOString()))? '#cccccc' : 'white'}"
              [disabled]="(series[dtp.end.toISOString()] && series[dtp.end.toISOString()].saving) || !saveAllowed(series, dtp.end.toISOString())"/>
            @if (series[dtp.end.toISOString()] && series[dtp.end.toISOString()].save_state === 'failed') {
              <span
                [id]="'save_err_mobile_' + series.id + '_' + tileId"
                class="cdk-visually-hidden">{{series[dtp.end.toISOString()].save_error}}</span>
            }
          </div>
          @if (series_events[series.id]) {
            <div
              style="padding:2px 4px 2px 2px;"><i class="icon-inline-comment" (click)="toggleComments(true)"></i>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>
